// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-subscribing-period[data-v-6178c526],.unsubscribed-at[data-v-6178c526]{margin-bottom:20px}.unsubscribed-at[data-v-6178c526]{align-items:center;display:flex;justify-content:center;margin-top:20px}", ""]);
// Exports
module.exports = exports;
